module.exports = __webpack_public_path__ + "img/documents-sarah_receitas.e823225b.svg";